import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// translation
import ru from 'translation/ru.json';
import ky from 'translation/ky.json';
// Тексты лендингов Binance лежат отдельно, ключи — binance.*
import binanceRu from 'translation/binance/ru.json';
import binanceKy from 'translation/binance/ky.json';


const resources = {
  ru: { translation: { ...ru, binance: binanceRu } },
  ky: { translation: { ...ky, binance: binanceKy } },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('lang') ?? 'ru',
    fallbackLng: 'ru',
    interpolation: { escapeValue: false }
  });

// Язык страницы для скринридеров и поисковиков.
document.documentElement.lang = i18n.language;
